module.exports = __webpack_public_path__ + "static/media/cancel-icon.38d8be2a.svg";